exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#f-global-content{padding-top:64px;transition:all .45s cubic-bezier(.23,1,.32,1)}@media (min-width:768px) and (max-width:992px){#f-global-content{padding-left:16px;padding-right:16px}}@media (min-width:992px){#f-global-content{padding-left:32px;padding-right:32px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/containers/base/yard.css
 ** module id = 563
 ** module chunks = 0
 **/